// extracted by mini-css-extract-plugin
export default {"cls1":"common-cls1_ydQ","cls2":"common-cls2__wY common-cls1_ydQ"};